import { Link } from 'react-router-dom';

interface Crumb {
  label: string;
  to?: string;
}

const Breadcrumb = ({ items }: { items: Crumb[] }) => (
  <nav aria-label="面包屑导航" className="border-b border-background-200/70 bg-background-100/40">
    <ol className="mx-auto flex max-w-content flex-wrap items-center gap-x-2 gap-y-1 px-4 py-3 text-xs text-foreground-500 md:px-6 md:text-sm">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <li key={`${item.label}-${index}`} className="flex items-center gap-2">
            {item.to && !isLast ? (
              <Link to={item.to} className="transition-colors hover:text-primary-600">
                {item.label}
              </Link>
            ) : (
              <span className={isLast ? 'text-foreground-800' : ''}>{item.label}</span>
            )}
            {!isLast && <i className="ri-arrow-right-s-line text-sm text-foreground-400"></i>}
          </li>
        );
      })}
    </ol>
  </nav>
);

export default Breadcrumb;